import { isPricingModelTiered } from 'customer-data-objects/product/Pricing';
import { useEffect, useMemo, useState } from 'react';
import { useAdditionalPropertyValues } from '../../../v2/hooks/useAdditionalPropertyValues';
import { useGetTierRangesAndPrices } from '../hooks/useGetTierRangesAndPrices';
import { TieredPriceModalHeaderSection } from './TieredPriceModalHeaderSection';
import { TieredPriceModalTableSection } from './TieredPriceModalTableSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isNonEmptyString = value => typeof value === 'string' && value.trim() !== '';
export const TieredPriceModalContainer = ({
  currencyCode
}) => {
  const [effectiveCurrencyCode, setEffectiveCurrencyCode] = useState(currencyCode);
  const tierRangesAndPrices = useGetTierRangesAndPrices();
  const currencyCodesWithTiersData = useMemo(() => {
    return Array.from(tierRangesAndPrices.keys()).filter(isNonEmptyString);
  }, [tierRangesAndPrices]);
  useEffect(() => {
    // If the currency code is not in the list of currency codes that have tiers data, set the effective currency code to the first currency code that has tiers data.
    if (currencyCode && currencyCodesWithTiersData.length > 0 && !currencyCodesWithTiersData.includes(currencyCode)) {
      setEffectiveCurrencyCode(currencyCodesWithTiersData[0]);
    }
    // We only want to run this effect once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const {
    data: additionalValues
  } = useAdditionalPropertyValues({
    pricingModel: 'hs_pricing_model'
  });
  const pricingModel = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.pricingModel;

  // The modal should only be rendered if the pricing model is one of the tiered pricing models.
  if (!isPricingModelTiered(pricingModel)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TieredPriceModalHeaderSection, {
      effectiveCurrencyCode: effectiveCurrencyCode,
      currencyCodesWithTiersData: currencyCodesWithTiersData,
      pricingModel: pricingModel,
      setEffectiveCurrencyCode: setEffectiveCurrencyCode
    }), /*#__PURE__*/_jsx(TieredPriceModalTableSection, {
      currencyCode: effectiveCurrencyCode,
      pricingModel: pricingModel
    })]
  });
};